import axiosInstance from "../Instance/axiosInstance";

export const getAllInventory = async () => {
  return axiosInstance.get("/inventory");
};


// UPDATE INVENTORY
export const updateInventory = async (payload) => {
  return axiosInstance.post("/update-inventory", payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};